import { Box, BoxProps, Container, Flex, Grid, SystemStyleObject } from '@chakra-ui/react';
import { KollectionType } from '@cyberkongz/api-interfaces';
import { pxToRem } from '@cyberkongz/ui';
import { PARTICLES_CONFIG, useParticles } from '@hooks/useParticles';
import { PropsWithChildren, ReactNode } from 'react';
import Particles from 'react-tsparticles';

import { KongBackButton } from './KongInfo';

export function Label({ children, color }: PropsWithChildren & BoxProps) {
  return (
    <Box
      css={{
        color: color || 'textSecondary',
        fontWeight: 'medium',
        fontSize: 'sm',
        textTransform: 'uppercase',
      }}
    >
      {children}
    </Box>
  );
}

// TO DO add inserting components after viewer will be done
// rework to template, like {infoComponent} {ownerComponent}
export function KongPageWrapper({
  css,
  type,
  infoComponent,
  podComponent,
  tabsComponent,
}: {
  css?: SystemStyleObject;

  type: KollectionType;
  infoComponent: ReactNode;
  podComponent: ReactNode;
  tabsComponent: ReactNode;
}) {
  return (
    <Flex
      css={{
        width: '100%',
        alignItems: 'center',
        overflowX: 'clip',
        ...css,
      }}
    >
      <Container
        css={{
          minHeight: [pxToRem(500), pxToRem(780)],
          pt: [pxToRem(100), pxToRem(124)],
          pb: 16,
          display: 'flex',
          width: '100%',
        }}
      >
        <Grid
          css={{
            position: 'relative',
            width: '100%',
            gridTemplateColumns: [
              '1fr',
              `1fr ${pxToRem(326)}`,
              `${pxToRem(286)} 1fr ${pxToRem(286)}`,
            ],
            gap: 5,
          }}
        >
          <KongBackButton type={type} css={{ display: ['flex', null, 'none'] }} />
          <Flex css={{ display: ['none', null, 'flex'] }}>{infoComponent}</Flex>
          {podComponent}
          <Box position="relative">{tabsComponent}</Box>
        </Grid>
      </Container>
    </Flex>
  );
}

export function KongParticles({ css }: { css?: SystemStyleObject }) {
  const { particlesInit } = useParticles();

  return (
    <Box
      css={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '120%',
        height: '150%',
        ...css,
        '#tsparticles': {
          width: '100%',
          height: '100%',
        },
      }}
    >
      <Particles id="tsparticles" init={particlesInit} options={PARTICLES_CONFIG} />
    </Box>
  );
}
